import { CSSProperties, forwardRef } from 'react'
import { Box } from '@mui/material'

interface CardProps {
  children: React.ReactNode
  style?: CSSProperties
  sx?: any
  elevation?: boolean
}

const CardBase = (props: CardProps, ref: any) => {
  const { children, style, sx, elevation } = props

  return (
    <Box
      // style={{
      //   backgroundColor: '#fff',
      //   backgroundClip: 'border-box',
      //   border: !elevation ? '0 solid rgba(0,0,0,.125)' : '',
      //   borderRadius: '0.5rem',
      //   ...style,
      //   boxShadow:
      //     'rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 1px 3px 1px'
      // }}
      ref={ref}
      style={{
        background: 'white',
        borderRadius: 4,
        // boxShadow: '0.5px 1.5px 1px #ccc',
        border: !elevation ? '1px solid #e0e0e0' : '',
        boxShadow: elevation
          ? '0.5px 1.5px 1px rgba(0,0,0,0.19), 0 3px 3px rgba(0,0,0,0.23)'
          : '',
        ...style
      }}
      sx={{ padding: { md: 3, xs: 0 }, ...sx }}
    >
      {children}
    </Box>
  )
}

export const Card = forwardRef(CardBase)
